import {
	IGetUserDetailResponse,
	IGetUserSettingParametersResponse,
	IGetUserSettingPermissionsResponse
} from '../../../components/Login/entities';
import { GetMethod } from '../../serviceHelper';

const getMethods = (service: 'login', controller: 'UserStartup') => ({
	GetAccountPermissionSetting: new GetMethod<IGetUserSettingPermissionsResponse, null>({
		service,
		controller,
		method: 'GetAccountPermissionSetting'
	}),
	GetUserProfileImageDownloadUrl: new GetMethod<string, null>({
		service,
		controller,
		method: 'GetUserProfileImageDownloadUrl'
	}),
	GetUserSettingParameters: new GetMethod<IGetUserSettingParametersResponse, null>({
		service,
		controller,
		method: 'GetUserSettingParameters'
	}),
	GetUserStartupInfo: new GetMethod<IGetUserDetailResponse, null>({
		service,
		controller,
		method: 'GetUserStartupInfo'
	}),
	GetUserProfileImageUploadUrl: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetUserProfileImageUploadUrl'
	})
});

export { getMethods };
